import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Host } from '@interfaces/host';
import { WsPaymentItem } from '../payments-list-tab/payments-list-tab.component';
import { PaymentsPaymentDetailDialogData } from './payments-payment-detail-dialog.data';

@Component({
  selector: 'web-payments-payment-detail-dialog',
  templateUrl: './payments-payment-detail-dialog.component.html',
  styleUrls: ['./payments-payment-detail-dialog.component.scss'],
})
export class PaymentsPaymentDetailDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PaymentsPaymentDetailDialogData,
    private dialogRef: MatDialogRef<PaymentsPaymentDetailDialogComponent>,
  ) {}

  onDetailClosed(): void {
    this.dialogRef.close();
  }

  onPaymentChanged(payment: WsPaymentItem): void {
    this.data.onPaymentChanged?.(payment);
  }
}

@Injectable({ providedIn: 'root' })
export class PaymentsPaymentDetailDialogService {
  constructor(private dialog: MatDialog) {}

  open(
    company: Host.Company,
    paymentIntentId: string,
    onPaymentChanged?: (payment: WsPaymentItem) => void,
    reservationId?: string,
    options?: { orderNumber?: string; shopName?: string },
  ): void {
    const id = paymentIntentId?.trim();
    if (!company?.id || !id) {
      return;
    }
    const data: PaymentsPaymentDetailDialogData = {
      company,
      paymentIntentId: id,
      reservationId,
      orderNumber: options?.orderNumber,
      shopName: options?.shopName,
      onPaymentChanged,
    };
    this.dialog.open(PaymentsPaymentDetailDialogComponent, {
      width: 'min(460px, calc(100vw - 2rem))',
      maxWidth: 'calc(100vw - 1rem)',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'payments-payment-detail-dialog-panel',
      data,
    });
  }
}
